export const CITIES = [
    "Abu Dhabi",
    "Almaty",
    "Amman",
    "Amsterdam",
    "Anchorage",
    "Arkansas",
    "Athens",
    "Atlanta",
    "Auckland",
    "Baltimore",
    "Bangkok",
    "Barcelona",
    "Beijing",
    "Beirut",
    "Berlin",
    "Berne",
    "Bilbao",
    "Bogota",
    "Boston",
    "Brisbane",
    "Brussels",
    "Bucharest",
    "Budapest",
    "Buenos Aires",
    "Cairo",
    "Calcutta",
    "Calgary",
    "Cardiff",
    "Casablanca",
    "Charleston",
    "Chicago",
    "Cincinnati",
    "Cleveland",
    "Colombo",
    "Copenhagen",
    "Dallas",
    "Denver",
    "Dili",
    "Doha",
    "Dubai",
    "Dublin",
    "Dusseldorf",
    "Edinburgh",
    "Edmonton",
    "Florida",
    "Frankfurt",
    "Fukuoka",
    "Geneva",
    "Glasgow",
    "Halifax",
    "Hamburg",
    "Hanover",
    "Harbin",
    "Helsinki",
    "Hong Kong",
    "Houston",
    "Indianapolis",
    "Istanbul",
    "Jakarta",
    "Jersey City",
    "Johannesburg",
    "Karachi",
    "Kiev",
    "Kuala Lumpur",
    "Lima",
    "Lisbon",
    "Ljubljana",
    "London",
    "Los Angeles",
    "Luxembourg",
    "Lyon",
    "Madrid",
    "Manama",
    "Manaus",
    "Manila",
    "Melbourne",
    "Mexico City",
    "Miami",
    "Michigan",
    "Milan",
    "Milwaukee",
    "Minneapolis",
    "Missouri",
    "Monaco",
    "Montreal",
    "Moscow",
    "Mumbai",
    "Munich",
    "Muscat",
    "Nagoya",
    "New Orleans",
    "New York",
    "Newark",
    "Nicosia",
    "Ohio",
    "Osaka",
    "Oslo",
    "Paris",
    "Perth",
    "Philadelphia",
    "Pittsburg",
    "Portland ME",
    "Portland OR",
    "Prague",
    "Princeton",
    "Reykjavik",
    "Richmond",
    "Riyadh",
    "Rockville",
    "Rome",
    "Safat",
    "San Diego",
    "San Francisco",
    "Sandton",
    "Santiago",
    "Sao Paulo",
    "Sapporo",
    "Seattle",
    "Seoul",
    "Shanghai",
    "Shenzhen",
    "Singapore",
    "St. Petersburg",
    "Stamford",
    "Stockholm",
    "Strasbourg",
    "Stuttgart",
    "Sydney",
    "Taipei",
    "Tallinn",
    "Tel Aviv",
    "Tennessee",
    "Tijuana",
    "Tokyo",
    "Toronto",
    "UNKNOWN",
    "Valletta",
    "Vancouver",
    "Victoria",
    "Vienna",
    "Vilnius",
    "Warsaw",
    "Washington DC",
    "Wellington",
    "Winnipeg",
    "Zagreb",
    "Zug",
    "Zurich"
];



/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/components/cities.js
 **/